// import React, { useState, useEffect } from "react";
// import {
//   Card, CardBody, Row, Col, Button, Input, Label, Form
// } from "reactstrap";
// import { useNavigate } from "react-router-dom";
// import { PurchaseProductList_Product } from "../../ApiEndPoint/Api";
// import { _Get, CreateCustomerList } from "../../ApiEndPoint/ApiCalling";

// export default function CreateSalesInvoice() {

//   const navigate = useNavigate();

//   // 🔹 PARTY + DATA
//   const [partyList, setPartyList] = useState([]);
//   const [Party, setParty] = useState({});
// const [selectedParty, setSelectedParty] = useState("");
//   // 🔹 HEADER FIELDS
//   const [orderDate, setOrderDate] = useState("2026-05-01");
//   const [InvoiceNumber, setInvoiceNumber] = useState("008");
// const [productList, setProductList] = useState([]);
//   // 🔹 LEDGER VALUES (demo)
//   const [openingLimit, setOpeningLimit] = useState(400000);
//   const [ledgerBalance, setLedgerBalance] = useState(236.38);
//   const [pendingAmount, setPendingAmount] = useState(0);

//   // 🔹 PRODUCTS
//   const [product, setProduct] = useState([
//     {
//       productName: "",
//       HSN_Code: "",
//       qty: 1,
//       GrossQty: 1,
//       availableQty: 0,
//       primaryUnit: "Unit",
//       secondaryUnit: "Gross Unit",
//       salePrice: 0,
//       basicPrice: 0,
//       gstPercentage: 0,
//       taxableAmount: 0,
//     },
//   ]);

//   // 🔹 DEMO PARTY LIST
// useEffect(() => {
//   fetchParties();
// }, []);

// const fetchParties = async () => {
//   try {
//     const userdata = JSON.parse(localStorage.getItem("userData"));

//     let id =
//       userdata?.rolename?.roleName === "SuperAdmin"
//         ? userdata._id
//         : userdata.created_by;

//     const res = await CreateCustomerList(id, userdata?.database);

//     let value = res?.Customer || [];

//     const formattedData = value.map((item) => ({
//       ...item,
//       displayLabel: `${item.CompanyName} (Grade: ${
//         item?.category?.grade?.toUpperCase() || "NA"
//       })`,
//     }));

//     setPartyList(formattedData);

//     console.log("PartyList 👉", formattedData);
//   } catch (err) {
//     console.log(err);
//   }
// };
// useEffect(() => {
//   fetchProducts();
// }, []);

// const fetchProducts = async () => {
//   try {
//     const userdata = JSON.parse(localStorage.getItem("userData"));

//     const res = await _Get(PurchaseProductList_Product, userdata?.database);

//     const products = res?.Product || [];

//     setProductList(products);

//     console.log("ProductList 👉", products);
//   } catch (err) {
//     console.log(err);
//   }
// };
// const handleProductSelect = (e, index) => {
//   const productId = e.target.value;

//   const selected = productList.find(p => p._id === productId);

//   const updated = [...product];

//   updated[index] = {
//     ...updated[index],
//     productId: selected._id,
//     Product_Title: selected.Product_Title,
//     HSN_Code: selected.HSN_Code,
//     primaryUnit: selected.primaryUnit,
//     secondaryUnit: selected.secondaryUnit,
//     salePrice: selected.salePrice,
//     basicPrice: selected.salePrice,
//     gstPercentage: selected.gstPercentage,
//     availableQty: selected.availableQty || 0,
//     qty: 1,
//     taxableAmount: selected.salePrice
//   };

//   setProduct(updated);
// };
//   // 🔹 ADD PRODUCT
//   const addMoreProduct = () => {
//     setProduct([
//       ...product,
//       {
//         productName: "",
//         HSN_Code: "",
//         qty: 1,
//         GrossQty: 1,
//         availableQty: 0,
//         primaryUnit: "Unit",
//         secondaryUnit: "Gross Unit",
//         salePrice: 0,
//         basicPrice: 0,
//         gstPercentage: 0,
//         taxableAmount: 0,
//       },
//     ]);
//   };

//   // 🔹 REMOVE PRODUCT
//   const removeMoreProduct = (index) => {
//     const updated = [...product];
//     updated.splice(index, 1);
//     setProduct(updated);
//   };

//   // 🔹 HANDLE CHANGE
//  const handleChange = (e, index) => {
//   const { name, value } = e.target;

//   const updated = [...product];
//   updated[index][name] = Number(value);

//   // 🔥 auto calc
//   const qty = updated[index].qty || 0;
//   const price = updated[index].basicPrice || 0;

//   updated[index].taxableAmount = qty * price;

//   setProduct(updated);
// };

//   const netBalance =
//     openingLimit + ledgerBalance - pendingAmount;

//   return (
//     <div>
//       <Card>
//         <Row className="m-1">
//           <Col>
//             <h4>Create Sales Invoice</h4>
//           </Col>

//           <Col className="text-end">
//             <Button
//               color="danger"
//               size="sm"
//               onClick={() =>
//                 navigate("/sales-and-purchases?view=sales-invoices")
//               }
//             >
//               Back
//             </Button>
//           </Col>
//         </Row>

//         <CardBody>
//           <Form>

//             {/* 🔥 HEADER */}
//             <Row>

//              <Col lg="3">
//   <Label>Choose Party *</Label>
//   <Input
//     type="select"
//     value={selectedParty}
//     onChange={(e) => {
//       const partyId = e.target.value;
//       setSelectedParty(partyId);

//       const partyObj = partyList.find(p => p._id === partyId);
//       setParty(partyObj); // 👈 full object store
//     }}
//   >
//     <option value="">Select Party</option>
//     {partyList.map((p) => (
//       <option key={p._id} value={p._id}>
//         {p.CompanyName}
//       </option>
//     ))}
//   </Input>
// </Col>

//               <Col lg="2">
//                 <Label>Order Date *</Label>
//                 <Input
//                   type="date"
//                   value={orderDate}
//                   onChange={(e) => setOrderDate(e.target.value)}
//                 />
//               </Col>

//               <Col lg="2">
//                 <Label>Invoice Number *</Label>
//                 <Input
//                   value={InvoiceNumber}
//                   onChange={(e) => setInvoiceNumber(e.target.value)}
//                 />
//               </Col>

//               <Col lg="2">
//                 <Label>Sanction Amount *</Label>
//                 <Input value={openingLimit} readOnly />
//                 <small style={{ color: "red" }}>
//                   Ledger Balance: {ledgerBalance} (Credit)
//                 </small>
//               </Col>

//               <Col lg="2">
//                 <Label>Pending Amount *</Label>
//                 <Input value={pendingAmount} readOnly />
//               </Col>

//               <Col lg="2">
//                 <Label>Balance Amount *</Label>
//                 <Input value={netBalance} readOnly />
//               </Col>

//               <Col lg="2">
//                 <Label>Net Balance *</Label>
//                 <Input value={netBalance} readOnly />
//               </Col>

//             </Row>

//             {/* 🔥 PRODUCTS */}
//             {product.map((p, index) => (
//               <Row key={index} className="mt-2">

//                 <Col lg="2">
//                   <Label>Select Product *</Label>
//                   <Input
//   type="select"
//   value={product[index]?.productId || ""}
//   onChange={(e) => handleProductSelect(e, index)}
// >
//   <option value="">Select Product</option>
//   {productList.map((p) => (
//     <option key={p._id} value={p._id}>
//       {p.Product_Title}
//     </option>
//   ))}
// </Input>
//                 </Col>

//                 <Col lg="1">
//                   <Label>HSN</Label>
//                   <Input value={p.HSN_Code} readOnly />
//                 </Col>

//                 <Col lg="1">
//                   <Label>Gross Qty</Label>
//                   <Input
//                     type="number"
//                     value={p.GrossQty}
//                     onChange={(e) =>
//                       handleChange(index, "GrossQty", e.target.value)
//                     }
//                   />
//                 </Col>

//                 <Col lg="1">
//                   <Label>Avail Qty</Label>
//                   <Input value={p.availableQty} readOnly />
//                 </Col>

//                 <Col lg="1">
//                   <Label>Net Qty</Label>
//                   <Input
//                     type="number"
//                     value={p.qty}
//                     onChange={(e) =>
//                       handleChange(index, "qty", e.target.value)
//                     }
//                   />
//                 </Col>

//                 <Col lg="1">
//                   <Label>Unit</Label>
//                   <Input value={p.primaryUnit} readOnly />
//                 </Col>

//                 <Col lg="1">
//                   <Label>Sales Price</Label>
//                   <Input
//                     type="number"
//                     value={p.salePrice}
//                     onChange={(e) =>
//                       handleChange(index, "salePrice", e.target.value)
//                     }
//                   />
//                 </Col>

//                 <Col lg="1">
//                   <Label>Basic Price</Label>
//                   <Input
//                     type="number"
//                     value={p.basicPrice}
//                     onChange={(e) =>
//                       handleChange(index, "basicPrice", e.target.value)
//                     }
//                   />
//                 </Col>

//                 <Col lg="1">
//                   <Label>Tax %</Label>
//                   <Input value={p.gstPercentage} readOnly />
//                 </Col>

//                 <Col lg="1">
//                   <Label>Basic Total</Label>
//                   <Input value={p.taxableAmount} readOnly />
//                 </Col>

//                 <Col lg="1" className="mt-4">
//                   {index > 0 && (
//                     <Button
//                       color="danger"
//                       size="sm"
//                       onClick={() => removeMoreProduct(index)}
//                     >
//                       X
//                     </Button>
//                   )}
//                 </Col>

//               </Row>
//             ))}

//             {/* 🔥 ADD BUTTON */}
//             <Row>
//               <Col className="text-end mt-2">
//                 <Button size="sm" onClick={addMoreProduct}>
//                   + Add
//                 </Button>
//               </Col>
//             </Row>

//             {/* 🔥 SUBMIT */}
//             <Row>
//               <Col className="text-center mt-3">
//                 <Button color="primary">
//                   Submit
//                 </Button>
//               </Col>
//             </Row>

//           </Form>
//         </CardBody>
//       </Card>
//     </div>
//   );
// }



import React, { useState, useEffect } from "react";
import {
  Card, CardBody, Row, Col, Button, Input, Label, Form
} from "reactstrap";
import { useNavigate } from "react-router-dom";

import {
  Create_Existing_Invoice,
  PurchaseProductList_Product,
  view_create_order_history,
  View_Ledger_by_id
} from "../../ApiEndPoint/Api";

import {
  _Get,
  _PostSave,
  CreateCustomerList,
  PurchaseOrderList
} from "../../ApiEndPoint/ApiCalling";
import axiosConfig from "../../AxiosConfig"
import swal from "sweetalert";
export default function CreateSalesInvoice() {

  const navigate = useNavigate();

  // ================= STATE =================
  const [partyList, setPartyList] = useState([]);
  const [productList, setProductList] = useState([]);
const [customerLimit, setCustomerLimit] = useState(0);
  const [Party, setParty] = useState({});
  const [selectedParty, setSelectedParty] = useState("");

  const [orderDate, setOrderDate] = useState("2026-05-01");
  const [InvoiceNumber, setInvoiceNumber] = useState("008");

  const [openingLimit, setOpeningLimit] = useState(0);
  const [ledgerBalance, setLedgerBalance] = useState("0");
  const [pendingAmount, setPendingAmount] = useState(0);

  const [product, setProduct] = useState([
    {
      productId: "",
      Product_Title: "",
      HSN_Code: "",
      qty: 1,
      GrossQty: 1,
      availableQty: 0,
      primaryUnit: "Unit",
      secondaryUnit: "Gross Unit",
      salePrice: 0,
      basicPrice: 0,
      gstPercentage: 0,
      taxableAmount: 0,
    },
  ]);

  // ================= API CALLS =================

  useEffect(() => {
    fetchParties();
    fetchProducts();
  }, []);

  const fetchParties = async () => {
    try {
      const userdata = JSON.parse(localStorage.getItem("userData"));

      let id =
        userdata?.rolename?.roleName === "SuperAdmin"
          ? userdata._id
          : userdata.created_by;

      const res = await CreateCustomerList(id, userdata?.database);
      const formatted = res?.Customer?.map((item) => ({
        ...item,
        displayLabel: `${item.CompanyName} (Grade: ${
          item?.category?.grade?.toUpperCase() || "NA"
        })`,
      }));

      setPartyList(formatted || []);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchProducts = async () => {
    try {
      const userdata = JSON.parse(localStorage.getItem("userData"));

      // const res = await _Get(
      //   PurchaseProductList_Product,
      //   userdata?.database
      // );
      const res = await axiosConfig.get(`/product/view-product-purchase/${userdata.database}`)
      setProductList(res?.data?.Product || []);
    } catch (err) {
      console.log(err);
    }
  };

  // ================= PARTY SELECT =================
const handlePartyChange = async (e) => {
  const partyId = e.target.value;
  setSelectedParty(partyId);

  const selectedItem = partyList.find(p => p._id === partyId);
  if (!selectedItem) return;

  setParty(selectedItem);

  // 🔥 1. Auto Invoice Number
  const number = await unique3Digit();
  setInvoiceNumber(number);

  // 🔥 2. Sanction Amount
  const limit = Number(selectedItem?.limit || 0);
  setOpeningLimit(limit);

  // 🔥 3. Opening Balance
  let openingBalance = Number(selectedItem?.OpeningBalance || 0);
  let openingType = selectedItem?.Type?.toLowerCase();

  let totalDebit = 0;
  let totalCredit = 0;

  try {
    const res = await axiosConfig.get(`/ledger/view-ledger-party/${selectedItem._id}`);

    if (res?.Ledger?.length > 0) {
      res.Ledger.forEach((entry) => {
        totalDebit += Number(entry?.debit || 0);
        totalCredit += Number(entry?.credit || 0);
      });
    }

  } catch (err) {
    if (err?.response?.status !== 404) {
      console.warn("Ledger error:", err);
    }
  }

  // 🔥 Opening adjust
  if (openingType === "debit") totalDebit += openingBalance;
  else if (openingType === "credit") totalCredit += openingBalance;

  // 🔥 Final Ledger Balance
  const finalBalance = totalDebit - totalCredit;
  const balanceType = finalBalance >= 0 ? "Debit" : "Credit";

  setLedgerBalance(
    `${Math.abs(finalBalance).toFixed(2)} (${balanceType})`
  );

  // 🔥 4. Pending Calculation (real logic)
  let totalPendingSales = 0;
  let totalPendingPurchase = 0;

  const userData = JSON.parse(localStorage.getItem("userData"));

  try {
    const salesRes = await axiosConfig.get(
      "/order/view-create-order-history/",
      userData?._id,
      userData?.database
    );
    if (salesRes?.orderHistory) {
      const pendingSales = salesRes.orderHistory.filter(
        (order) =>
          ["pending", "Dispatch", "Billing"].includes(order.status) &&
          order?.partyId?._id === selectedItem._id
      );

      totalPendingSales = pendingSales.reduce(
        (acc, cur) => acc + (cur.grandTotal || 0),
        0
      );
    }

  } catch (err) {
    console.warn("Sales pending error:", err);
  }

  try {
    const purchaseRes = await PurchaseOrderList(
      userData?._id,
      userData?.database
    );

    if (purchaseRes?.orderHistory) {
      const pendingPurchase = purchaseRes.orderHistory.filter(
        (po) =>
          po.status === "pending" &&
          po?.partyId?._id === selectedItem._id
      );

      totalPendingPurchase = pendingPurchase.reduce(
        (acc, cur) => acc + (cur.grandTotal || 0),
        0
      );
    }

  } catch (err) {
    console.warn("Purchase pending error:", err);
  }

  const adjustedPending = totalPendingPurchase - totalPendingSales;
  setPendingAmount(adjustedPending);

  // 🔥 5. Final Limit Calculation
  let finalLimit =
    balanceType === "Debit"
      ? limit - Math.abs(finalBalance)
      : limit + Math.abs(finalBalance);

  finalLimit += adjustedPending;

  setCustomerLimit(finalLimit);

  console.log("Final Limit 👉", finalLimit);
};
  // ================= PRODUCT SELECT =================

  const handleProductSelect = (e, index) => {
    const productId = e.target.value;

    const selected = productList.find(p => p._id === productId);
    if (!selected) return;

    const updated = [...product];

    updated[index] = {
      ...updated[index],
      productId: selected._id,
      Product_Title: selected.Product_Title,
      HSN_Code: selected.HSN_Code,
      primaryUnit: selected.primaryUnit,
      secondaryUnit: selected.secondaryUnit,
      salePrice: Number(selected.Product_MRP || 0),
      basicPrice: Number(selected.Product_MRP || 0),
      gstPercentage: Number(selected.GSTRate || 0),
      availableQty: selected.qty || 0,
      qty: 1,
      GrossQty: 1,
      taxableAmount: Number(selected.Product_MRP || 0),
    };

    setProduct(updated);
  };

  // ================= INPUT CHANGE =================

  const handleChange = (e, index) => {
    const { name, value } = e.target;

    const updated = [...product];
    updated[index][name] = Number(value);

    const qty = updated[index].qty || 0;
    const price = updated[index].basicPrice || 0;

    updated[index].taxableAmount = qty * price;

    setProduct(updated);
  };

  // ================= ADD / REMOVE =================

  const addMoreProduct = () => {
    setProduct([
      ...product,
      {
        productId: "",
        Product_Title: "",
        HSN_Code: "",
        qty: 1,
        GrossQty: 1,
        availableQty: 0,
        primaryUnit: "Unit",
        secondaryUnit: "Gross Unit",
        salePrice: 0,
        basicPrice: 0,
        gstPercentage: 0,
        taxableAmount: 0,
      },
    ]);
  };

  const removeMoreProduct = (index) => {
    const updated = [...product];
    updated.splice(index, 1);
    setProduct(updated);
  };

  // ================= CALC =================

  const netBalance = openingLimit - pendingAmount;

  const grandTotal = product.reduce(
    (acc, item) => acc + Number(item.taxableAmount || 0),
    0
  );

  // ================= SUBMIT =================

const handleSubmit = async () => {
  try {
    const payload = {
      partyId: Party?._id,
      invoiceId: InvoiceNumber,
      date: orderDate,
      orderItems: product,
      total: grandTotal,
    };

    console.log("FINAL PAYLOAD 👉", payload);

    const res = await _PostSave(
      Create_Existing_Invoice,
      payload
    );
    console.log("Invoice API Response 👉", res);

    swal({
      title: "Success",
      text: "Invoice Created Successfully",
      icon: "success",
      button: "OK",
    }).then(() => {
      navigate("/sales-and-purchases?view=sales-invoices");
    });

  } catch (error) {
    console.error("Invoice Create Error 👉", error);

    swal({
      title: "Error",
      text:
        error?.response?.data?.message ||
        "Something went wrong while creating invoice",
      icon: "error",
      button: "OK",
    });
  } 
};
const unique3Digit = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData"));

    const res = await _Get(
      view_create_order_history,
      userData._id,
      userData.database
    );

    let completedOrders =
      res?.orderHistory?.filter(
        (ele) =>
          ele?.status?.toLowerCase() === "completed" &&
          ele?.status?.toLowerCase() !== "deactive"
      ) || [];

    let previousInvoices = [
      ...new Set(
        completedOrders
          .map((order) => order?.invoiceId)
          .filter((id) => id && !isNaN(id))
          .map((id) => parseInt(id))
      ),
    ].sort((a, b) => a - b);

    for (let i = 1; i <= previousInvoices.length; i++) {
      if (!previousInvoices.includes(i)) {
        return i.toString().padStart(3, "0");
      }
    }

    let nextNumber =
      previousInvoices.length > 0
        ? Math.max(...previousInvoices) + 1
        : 1;

    return nextNumber.toString().padStart(3, "0");

  } catch (error) {
    console.error("Invoice Error:", error);
    return "001";
  }
};
useEffect(() => {
  generateInvoice();
}, []);

const generateInvoice = async () => {
  const number = await unique3Digit();
  setInvoiceNumber(number);
};
  // ================= UI =================

  return (
    <div>
      <Card>

        {/* HEADER */}
        <Row className="m-1">
          <Col><h4>Create Sales Invoice</h4></Col>
          <Col className="text-end">
            <Button
              color="danger"
              size="sm"
              onClick={() =>
                navigate("/sales-and-purchases?view=sales-invoices")
              }
            >
              Back
            </Button>
          </Col>
        </Row>

        <CardBody>
          <Form>

            {/* HEADER FIELDS */}
            <Row>

              <Col lg="3">
                <Label>Choose Party *</Label>
                <Input
                  type="select"
                  value={selectedParty}
                  onChange={handlePartyChange}
                >
                  <option value="">Select Party</option>
                  {partyList.map(p => (
                    <option key={p._id} value={p._id}>
                      {p.displayLabel}
                    </option>
                  ))}
                </Input>
              </Col>

              <Col lg="2">
                <Label>Order Date *</Label>
                <Input
                  type="date"
                  value={orderDate}
                  onChange={(e) => setOrderDate(e.target.value)}
                />
              </Col>

              <Col lg="2">
  <Label>
    Invoice Number <span style={{ color: "red" }}>*</span>
  </Label>
  <Input
    required
    type="text"
    value={InvoiceNumber}
    onChange={(e) => setInvoiceNumber(e.target.value)}
  />
</Col>

              <Col lg="2">
                <Label>Sanction Amount *</Label>
                <Input value={openingLimit.toFixed(2)} readOnly />
                <small style={{ color: "red" }}>
                  Ledger Balance: {ledgerBalance}
                </small>
              </Col>

              <Col lg="2">
                <Label>Pending Amount *</Label>
                <Input value={pendingAmount.toFixed(2)} readOnly />
              </Col>

              <Col lg="2">
                <Label>Net Balance *</Label>
                <Input value={netBalance.toFixed(2)} readOnly />
              </Col>

            </Row>

            {/* PRODUCTS */}
            {product.map((p, index) => (
              <Row key={index} className="mt-2">

                <Col lg="2">
                  <Label>Select Product *</Label>
                  <Input
                    type="select"
                    value={p.productId}
                    onChange={(e) => handleProductSelect(e, index)}
                  >
                    <option value="">Select Product</option>
                    {productList.map(prod => (
                      <option key={prod._id} value={prod._id}>
                        {prod.Product_Title}
                      </option>
                    ))}
                  </Input>
                </Col>

                <Col lg="1">
                  <Label>HSN</Label>
                  <Input value={p.HSN_Code} readOnly />
                </Col>

                <Col lg="1">
                  <Label>Gross Qty</Label>
                  <Input
                    name="GrossQty"
                    type="number"
                    value={p.GrossQty}
                    onChange={(e) => handleChange(e, index)}
                  />
                </Col>

                <Col lg="1">
                  <Label>Avail Qty</Label>
                  <Input value={p.availableQty} readOnly />
                </Col>

                <Col lg="1">
                  <Label>Net Qty</Label>
                  <Input
                    name="qty"
                    type="number"
                    value={p.qty}
                    onChange={(e) => handleChange(e, index)}
                  />
                </Col>

                <Col lg="1">
                  <Label>Unit</Label>
                  <Input value={p.primaryUnit} readOnly />
                </Col>

                <Col lg="1">
                  <Label>Price</Label>
                  <Input
                    name="basicPrice"
                    type="number"
                    value={p.basicPrice}
                    onChange={(e) => handleChange(e, index)}
                  />
                </Col>

                <Col lg="1">
                  <Label>Tax %</Label>
                  <Input value={p.gstPercentage} readOnly />
                </Col>

                <Col lg="1">
                  <Label>Total</Label>
                  <Input value={p.taxableAmount} readOnly />
                </Col>

                <Col lg="1" className="mt-4">
                  {index > 0 && (
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => removeMoreProduct(index)}
                    >
                      X
                    </Button>
                  )}
                </Col>

              </Row>
            ))}

            {/* ADD */}
            <Row>
              <Col className="text-end mt-2">
                <Button size="sm" onClick={addMoreProduct}>
                  + Add
                </Button>
              </Col>
            </Row>

            {/* TOTAL */}
            <Row>
              <Col className="text-end mt-2">
                <h5>Grand Total: ₹ {grandTotal.toFixed(2)}</h5>
              </Col>
            </Row>

            {/* SUBMIT */}
            <Row>
              <Col className="text-center mt-3">
                <Button color="primary" onClick={handleSubmit}>
                  Submit
                </Button>
              </Col>
            </Row>

          </Form>
        </CardBody>
      </Card>
    </div>
  );
}